/**
 * Created by Bart Decorte
 * Date: 13/11/2018
 * Time: 12:18
 */
import IndexPage from '../IndexPage';

class UsersIndex extends IndexPage {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }
}

export default UsersIndex;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Users/UsersIndex.js